<template>
    <el-table
        :data="unansweredQuestionnaire" 
        :show-header="false"
        row-key="id"
        cell-class-name="survey-cell"
        v-if="unansweredQuestionnaire.length > 0">
        <el-table-column width="450">
            <template slot-scope="scope">
                <div style="line-height:16px;padding-left:20px;font-size: 14px;font-weight: bold;">
                    {{ scope.row.display_name || scope.row.title }}
                    <span class="sub-head">Not yet Answered</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column>
            <template slot-scope="scope">
                <el-button class="answer-now" @click="$emit('answer-now', scope.row.id)" :disabled="getSurveyState[scope.row.id]">
                    <LoadSpinner style="height:12px;width:12px;" type="survey" v-if="getSurveyState[scope.row.id]"></LoadSpinner>
                    <span v-else>Answer Now</span>
                </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { mapGetters } from 'vuex'

import QuestionnaireCalcMixin from '../mixin/questionnaire-calc'

import CardTable from '../component/table'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'

export default {
    name: 'survey-table',

    extends: CardTable,

    mixins: [QuestionnaireCalcMixin],

    props: {
        patient: {
            type: Object,
            required: true
        },
        profileQuestionnaire: {
            type: Array
        }
    },

    computed: {
        ...mapGetters('provider', [
            'getPatientEvents',
            'getSurveyState'
        ]),
        unansweredQuestionnaire() {
            try {
                const patientEvents = this.getPatientEvents(this.patient.id)
                return this.profileQuestionnaire.filter((questionnaire) => {
                    return !patientEvents.some((event) => event.provider_survey && questionnaire.id === event.type.split(':')[1])
                })
            } catch (error) {
                console.error('Error during unansweredQuestionnaire', error)
                return []
            }
            
        }
    },

    components: {
        LoadSpinner
    }


}
</script>

<style lang="scss" >
.survey-cell {
    background-color: #f8f8f8;
    span.sub-head {
        display: block;
        color: #999999;
        font-size: 12px;
        font-weight: 500;
    }
}
.el-table {
    .answer-now {
        border: 1px solid #709F34;
        font-size: 12px;
        color: #709F34;
        padding: 7px 12px;
        width: 105px;
        height: 26px;
        float: right;
    }
    .answer-now:hover {
        background-color: transparent;
        border: 1px solid #709F34;
        color: #709F34;
    }
    .complete-now, .complete-now:active, .complete-now:focus {
        background: #FFEBEB;
        border: 1px solid #DA4E4E;
        font-size: 12px;
        color: #DA4E4E;
        padding: 6px 12px;
        width: 105px;
        height: 26px;
        float: right;
    }
    .complete-now:hover {
        background-color: #FFEBEB;
        border: 1px solid #DA4E4E;
        color: #DA4E4E;
    }
    .complete-now-arrow {
        background: #FFEBEB;
        border: 1px solid #DA4E4E;
        border-left: none;
        font-size: 12px;
        color: #DA4E4E;
        padding: 5px;
        width: 26px;
        height: 26px;
        float: right;
    }
    .complete-now-arrow:hover {
        background-color: #FFEBEB;
        border: 1px solid #DA4E4E;
        color: #DA4E4E;
    }
}

</style>